import Vue from 'vue'

import { store as menueStore } from '@/code-lab/component/layout/control-menue/observable.js'
export default {
    data:  () => ({ sort: '', folderType: menueStore.current, lockScroll: false }),
    methods: {
        del_folder$ (callBack, opts) {
            const prams = { folderId: null, ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                "cmd": "del_folder",
                "data": { ...data }
            }, response => {
                callBack(response)
            })
        },
        edit_folder$ (callBack, opts) { 
            const prams = { folderId: null, moveFolderId: null, name: '', ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                "cmd": "edit_folder",
                "data": { ...data }
            }, response => {
                callBack(response)
            })
        },
        add_folder$ (callBack, opts) {
            const prams = { path: '/', ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                cmd: 'add_folder',
                data: { ...data, }
            }, res => {
                callBack(res)
            })
        },
        
        get_folder_list$ (callBack, opts, pageInfo = {}) {
            this.lockScroll = true;
            const prams = { path: '/', page: 1, limit: 20, folderId: null, folderType: menueStore.current, sort: '-dateTime', ...opts, ...pageInfo }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                cmd: 'get_folder_list',
                data: {
                    query: { ...data },
                }
            }, response => {
                callBack(response)
                setTimeout(() => {
                    this.lockScroll = false;
                }, 200);
            }) 
        },
        
        add_project$ (callBack, opts) {
            const prams = { folderId: null, name: '', ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                cmd: "add_project",
                data: { ...data, }
            }, response => {
                callBack(response)
            })
        },
        edit_project$ (callBack, opts) {
            const prams = { folderId: null, name: '', projectId: null, timelineDesc: null, ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                cmd: 'edit_project',
                data: { ...data }
            }, response => {
                callBack(response)
            })
        },
        del_project$ (callBack, opts) {
            const prams = { projectId: null, ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                "cmd": "del_project",
                "data": { ...data }
            }, response => {
                callBack(response)
            })
        },
        export_execute_file$ (callBack, opts) {
            const prams = { projectId: '', ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                cmd: "export_execute_file",
                data: { ...data, }
            }, response => {
                callBack(response, data)
            })
        },
        
        move_project$ (callBack, opts) {
            const prams = { projectIds: null, folderId: null, ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                "cmd": "move_project",
                data: { ...data }
            }, response => {
                callBack(response)
            })
        },
        clone_project$ (callBack, opts) {
            const prams = { projectId: null, name: Vue.prototype.$t("LANG_TEXT_NO_CONNECTED_DEVICE"), ...opts }
            const data = this.deleteEmptyKey(prams)
            this.b$.send('tool', {
                "cmd": "clone_project",
                data: { ...data }
            }, response => {
                callBack(response)
            })
        },

        clone_sample$(callBack, opt){
            const data = this.deleteEmptyKey(opt);
            this.b$.send('tool', {
                "cmd": "clone_sample_project",
                data
            }, response => {
                callBack(response)
            })
        },
        
        getRequestQuery (target, keyVal = 'openStatus') {
            const map = {
                private: ['openStatus'],
                public: ['openStatus'],
                group: ['openStatus', { groups: 'groupIds' }]
            }
            if (!target[keyVal]) {
                return map['private']
            }
            return map[target[keyVal]].reduce((a, b) => {
                typeof b === 'string' ? a[b] = target[b] : Object.entries(b).forEach(([key, val]) => a[val] = target[key])
                return a
            }, {})
        },
        deleteEmptyKey (data) {
            Object.entries(data).forEach(([key]) => {
                if (!data[key]) {
                    delete data[key]
                }
            })
            return data
        },
    },
}